// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models --tenant projectReplica` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating TaskAssignedUser records.
 * @typedef {object} TaskAssignedUserWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string | null} [taskId] - Value for the taskId attribute.
 * @property {string | null} [userId] - Value for the userId attribute.
 * @property {string | null} [userAssignedById] - Value for the userAssignedById attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 * @property {Date | string | null} [lastSyncChangeAt] - Value for the lastSyncChangeAt attribute.
 * @property {import("../models/task.js").default} [task] - Related task record.
 */

/** @augments {DatabaseRecord<TaskAssignedUserWriteAttributes>} */
export default class TaskAssignedUserBase extends DatabaseRecord {
  /** @returns {typeof import("../models/task-assigned-user.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/task-assigned-user.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string | null} */
  taskId() { return this.readAttribute("taskId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setTaskId(newValue) { return this._setColumnAttribute("taskId", newValue) }

  /** @returns {boolean} */
  hasTaskId() { return this._hasAttribute(this.taskId()) }

  /** @returns {string | null} */
  userId() { return this.readAttribute("userId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setUserId(newValue) { return this._setColumnAttribute("userId", newValue) }

  /** @returns {boolean} */
  hasUserId() { return this._hasAttribute(this.userId()) }

  /** @returns {string | null} */
  userAssignedById() { return this.readAttribute("userAssignedById") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setUserAssignedById(newValue) { return this._setColumnAttribute("userAssignedById", newValue) }

  /** @returns {boolean} */
  hasUserAssignedById() { return this._hasAttribute(this.userAssignedById()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /** @returns {Date | null} */
  lastSyncChangeAt() { return this.readAttribute("lastSyncChangeAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastSyncChangeAt(newValue) { return this._setColumnAttribute("lastSyncChangeAt", newValue) }

  /** @returns {boolean} */
  hasLastSyncChangeAt() { return this._hasAttribute(this.lastSyncChangeAt()) }

  /**
   * @returns {import("../models/task.js").default}
   */
  task() { return /** @type {import("../models/task.js").default} */ (this.getRelationshipByName("task").loaded()) }

  /**
   * @abstract
   * @param {ConstructorParameters<typeof import("../models/task.js").default>[0]} [attributes]
   * @returns {import("../models/task.js").default}
   */
  buildTask(attributes) { void attributes; throw new Error("Not implemented") }

  /**
   * @abstract
   * @returns {Promise<import("../models/task.js").default | undefined>}
   */
  loadTask() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<import("../models/task.js").default | undefined>}
   */
  taskOrLoad() { return /** @type {Promise<import("../models/task.js").default | undefined>} */ (this.relationshipOrLoad("task")) }

  /**
   * @abstract
   * @param {import("../models/task.js").default} newModel
   * @returns {void}
   */
  setTask(newModel) { void newModel; throw new Error("Not implemented") }
}
